import styled from "styled-components";
import { space } from "styled-system";

export const Svg = styled.svg`
  border-radius: 2px;
  ${space}
`;
